import { render, staticRenderFns } from "./NewBanner.vue?vue&type=template&id=1af5ce66"
import script from "./NewBanner.vue?vue&type=script&lang=js"
export * from "./NewBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports